import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { DriverEntity } from 'src/entities/Driver.entity';
import { TruckEntity } from 'src/entities/Truck.entity';

type Option = { id: number; label: string };

// useTrucks / useDrivers は on 必須で週の初めの active_until で絞るため使わない。
// 固定値は日付に依らず「今 active なもの」から選ぶので on なしで呼ぶ。
// visible は複数社を含みうるので、取込先の会社で絞り直す。
const fetchOptions = async <T extends { id: number; companyId: number; status?: string }>(
  path: string,
  companyId: number,
  toLabel: (entity: T) => string
): Promise<Option[]> => {
  const { data } = await axios.get<T[]>(path);

  return data
    .filter((it) => it.companyId === companyId && it.status === 'active')
    .map((it) => ({ id: it.id, label: toLabel(it) }));
};

export const useImportFixedValueMasters = (companyId: number) => {
  const trucks = useQuery({
    queryKey: ['importFixedValueTrucks', companyId],
    queryFn: () => fetchOptions<TruckEntity>('/api/v3/trucks', companyId, (it) => it.licensePlateValue)
  });
  const drivers = useQuery({
    queryKey: ['importFixedValueDrivers', companyId],
    queryFn: () => fetchOptions<DriverEntity>('/api/v3/drivers', companyId, (it) => it.name)
  });

  return {
    trucks: trucks.data ?? [],
    drivers: drivers.data ?? [],
    isLoading: trucks.isLoading || drivers.isLoading
  };
};
